
import Index from 'components/ckan/ckan/Index.jsx'

export default function CKANPage(){
  return(
    <Index />
  )
}
 
export async function getStaticProps() {
  return {
    props: {
      meta: {
        title: "CKAN",
        description: "Build everything from open data portals to enterprise data catalogs.",
      },
    },
  };
};